import request from "@/service";

/* 查询考试分页列表 */
export function getExamInfoList(params) {
  return request({
    url: `/study/exam/info/page`,
    method: "get",
    params
  });
}

/* 查询考试分页 根据班级id */
export function getExamInfoByClass(params) {
  return request({
    url: `/study/exam/info/pageForClass`,
    method: "get",
    params
  });
}

/* 考试新增 */
export function saveExamInfo(params) {
  return request({
    url: `/study/exam/info/save`,
    method: "post",
    data: params
  });
}

/* 考试人员查询 */
export function getExamUser(params) {
  return request({
    url: `/user/sys/dept/treeUser`,
    method: "get",
    params
  });
}

/* 新增考试人员 */
export function saveExamUser(data) {
  return request({
    url: `/study/exam/user/save`,
    method: "post",
    data
  });
}

/* 导入考试用户 */
export function importExamUser(params) {
  return request({
    url: `/study/exam/user/import`,
    method: "post",
    headers: {
      "Content-Type":
        "multipart/form-data; boundary=----WebKitFormBoundaryyJzVStTyqSc9B1Ut"
    },
    data: params
  });
}

/* 导出学员 */
export function exportExamUser(params) {
  return request({
    url: `/study/exam/user/export`,
    method: "put",
    responseType: "blob",
    headers: {
      Accept: "application/json, text/plain, */*, application/octet-stream",
      "Content-Type": "application/json;charset=UTF-8"
    },
    data: params
  });
}

/* 试卷修改 */
export function editExamInfo(params) {
  return request({
    url: `/study/exam/info/update`,
    method: "put",
    data: params
  });
}

/* 考试详情 */
export function getExamInfo(params) {
  return request({
    url: `/study/exam/info/info/${params}`,
    method: "get"
  });
}

/* 考试删除 */
export function deleteExam(params) {
  return request({
    url: `/study/exam/info/delete`,
    method: "delete",
    data: params
  });
}

/* 发布/取消发布 */
export function publishExamInfo(params) {
  return request({
    url: `/study/exam/info/publish`,
    method: "put",
    data: params
  });
}

/* 新增成绩生成试卷 */
export function ExamInfoManual(params) {
  return request({
    url: `/study/exam/info/manual/${params}`,
    method: "get"
  });
}

/* 新增成绩 */
export function ExamInfoManualSubmit(params) {
  return request({
    url: `/study/exam/info/manualSubmit`,
    method: "post",
    data: params
  });
}

/* 删除答题记录 */
export function deleteExamBatch(params) {
  return request({
    url: `/study/exam/batch/delete`,
    method: "delete",
    data: params
  });
}

/* 答题记录详情 */
export function getExamBatch(params) {
  return request({
    url: `/study/exam/batch/info/${params}`,
    method: "get"
  });
}

/* 班级考试：学员分页(考试管理) */
export function getExamStudentPage(params) {
  return request({
    url: `/study/class/enroll/examStudentPage`,
    method: "post",
    data: params
  });
}

/* 考试结果：分页列表 */
export function getExamResultPage(params) {
  return request({
    url: `/study/exam/info/resultPage`,
    method: "get",
    params
  });
}

/* 考试结果：分页列表 */
export function getResultMembersPage(params) {
  return request({
    url: `/study/exam/user/resultPage`,
    method: "get",
    params
  });
}

/* 考试结果：导出学员 */
export function resultExportUser(params) {
  return request({
    url: `/study/exam/user/exportExamResult`,
    method: "put",
    responseType: "blob",
    headers: {
      Accept: "application/json, text/plain, */*, application/octet-stream",
      "Content-Type": "application/json;charset=UTF-8"
    },
    data: params
  });
}
